import { BlankLayout } from '@/components/layouts';

export default {
  path: '/community',
  name: 'Community',
  component: BlankLayout,
  meta: { module: '社区' },
  children: [
    {
      path: '/community/topic/:id',
      name: 'Community.Topic.Details',
      component: () => import(/* webpackChunkName:'community-topic-details' */ '../../views/community/TopicDetails.vue'),
      meta: { title: '社区_话题详情页' },
    },
    {
      path: '/community/post/:id',
      name: 'Community.Post.Details',
      component: () => import(/* webpackChunkName: 'community-post-details' */ '../../views/community/PostDetails.vue'),
      meta: { title: '社区_帖子详情页' },
    },
    {
      path: '/community/article/:id',
      name: 'Community.Article.Details',
      component: () => import(/* webpackChunkName: 'community-post-details' */ '../../views/community/ArticleDetails.vue'),
      meta: { title: '社区_文章详情页' },
    },
  ],
};
